import type { Room } from '@hollowveil/shared';

export const roomTowerAscension: Room = {
      id: 'room_tower_ascension',
      name: "La Tour de l'Ascension",
      description: "Une tour vertigineuse. Un immense escalier en spirale mène vers le sommet où brille l'Orbe Céleste.",
      size: [30, 25, 30],
      floorStyle: 'stone',
      ambiance: {
        realWorld: {
          backgroundColor: '#2c3e50',
          ambientLightColor: '#95a5a6',
          ambientLightIntensity: 0.4,
        },
        spectralWorld: {
          backgroundColor: '#1a1a2e',
          ambientLightColor: '#7b68ee',
          ambientLightIntensity: 0.3,
        },
      },
      objects: [
        // === GROUND FLOOR ===
        // Welcome NPC
        {
          id: 'obj_tower_guardian',
          name: 'Gardien de la Tour',
          type: 'interactive',
          modelId: 'sage',
          position: [15, 0, 5],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: '"Bienvenue dans la Tour de l\'Ascension, voyageur.\n\nL\'Orbe Céleste t\'attend au sommet. Mais attention : certaines marches n\'existent que dans le monde spectral.\n\nAlterne entre les mondes pour trouver ton chemin vers le haut!"',
              },
            },
          ],
        },
        // === FIRST STAIRCASE (real world) - from ground to level 2 ===
        {
          id: 'obj_stair_1_1',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [8, 0, 8],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_1_2',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [8, 0.5, 10],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_1_3',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [8, 1, 12],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_1_4',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [8, 1.5, 14],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // First landing platform (level 2)
        {
          id: 'obj_tower_platform_1',
          name: 'Premier Palier',
          type: 'static',
          modelId: 'platform',
          position: [8, 2, 17],
          rotation: [0, 0, 0],
          scale: [5, 0.5, 5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Checkpoint trigger for first landing - large area trigger on platform
        {
          id: 'obj_landing_1',
          name: 'Premier Palier',
          type: 'trigger',
          modelId: 'block',
          position: [8, 2.5, 17],
          rotation: [0, 0, 0],
          scale: [4, 0.1, 4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { invisible: true },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: "Tu as atteint le premier palier! Continue vers le haut...\n\nIndice: Les prochaines marches n'apparaissent que dans le monde spectral.",
              },
            },
          ],
        },
        // === SECOND STAIRCASE (spectral only) - from level 2 to level 4 ===
        {
          id: 'obj_stair_2_1',
          name: 'Marche Spectrale',
          type: 'static',
          modelId: 'stairs',
          position: [11, 2, 19],
          rotation: [0, Math.PI / 2, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_2_2',
          name: 'Marche Spectrale',
          type: 'static',
          modelId: 'stairs',
          position: [13, 2.5, 19],
          rotation: [0, Math.PI / 2, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_2_3',
          name: 'Marche Spectrale',
          type: 'static',
          modelId: 'stairs',
          position: [15, 3, 19],
          rotation: [0, Math.PI / 2, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_2_4',
          name: 'Marche Spectrale',
          type: 'static',
          modelId: 'stairs',
          position: [17, 3.5, 19],
          rotation: [0, Math.PI / 2, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { walkable: true },
        },
        // Second landing platform (level 4)
        {
          id: 'obj_tower_platform_2',
          name: 'Second Palier',
          type: 'static',
          modelId: 'platform',
          position: [20, 4, 19],
          rotation: [0, 0, 0],
          scale: [5, 0.5, 5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Checkpoint trigger for second landing - large area trigger on platform
        {
          id: 'obj_landing_2',
          name: 'Second Palier',
          type: 'trigger',
          modelId: 'block',
          position: [20, 4.5, 19],
          rotation: [0, 0, 0],
          scale: [4, 0.1, 4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { invisible: true },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: "Excellent! Tu as trouvé les marches spectrales!\n\nLe dernier escalier est visible dans les deux mondes.",
              },
            },
          ],
        },
        // Spirit guide at second landing
        {
          id: 'obj_spirit_guide',
          name: 'Esprit Guide',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [22, 4, 17],
          rotation: [0, Math.PI, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: '"Tu es presque au sommet, voyageur...\n\nL\'Orbe Céleste récompense ceux qui persévèrent.\n\nLe dernier escalier t\'attend vers le nord."',
              },
            },
          ],
        },
        // === THIRD STAIRCASE (both worlds) - from level 4 to level 6 (summit) ===
        {
          id: 'obj_stair_3_1',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [20, 4, 22],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_3_2',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [20, 4.5, 24],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_3_3',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [20, 5, 26],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        {
          id: 'obj_stair_3_4',
          name: 'Marche',
          type: 'static',
          modelId: 'stairs',
          position: [20, 5.5, 28],
          rotation: [0, 0, 0],
          scale: [3, 0.5, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Summit platform (level 6)
        {
          id: 'obj_summit_platform',
          name: 'Sommet de la Tour',
          type: 'static',
          modelId: 'platform',
          position: [15, 6, 26],
          rotation: [0, 0, 0],
          scale: [8, 0.5, 8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Checkpoint trigger for summit - large area trigger on platform
        {
          id: 'obj_landing_3',
          name: 'Sommet',
          type: 'trigger',
          modelId: 'block',
          position: [15, 6.5, 26],
          rotation: [0, 0, 0],
          scale: [6, 0.1, 6],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { invisible: true },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: "Tu as atteint le sommet de la Tour de l'Ascension!\n\nL'Orbe Céleste t'attend...",
              },
            },
          ],
        },
        // === THE CELESTIAL ORB ===
        {
          id: 'obj_celestial_orb',
          name: 'Orbe Céleste',
          type: 'interactive',
          modelId: 'crystal',
          position: [15, 7, 26],
          rotation: [0, 0, 0],
          scale: [1.5, 2, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'celestial_orb',
                itemName: 'Orbe Céleste',
                itemDescription: "Un orbe qui brille de la lumière des étoiles. Tu l'as mérité en atteignant le sommet.",
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: "🌟 Tu as obtenu l'Orbe Céleste!\n\nTu as prouvé ta persévérance et ta maîtrise des deux mondes en atteignant le sommet de la tour.",
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_celestial_orb',
              },
            },
          ],
        },
        // === DECORATIVE ELEMENTS ===
        // Pillars around the tower
        {
          id: 'obj_tower_pillar_1',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [5, 0, 5],
          rotation: [0, 0, 0],
          scale: [1, 8, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_pillar_2',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [25, 0, 5],
          rotation: [0, 0, 0],
          scale: [1, 8, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_pillar_3',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [5, 0, 25],
          rotation: [0, 0, 0],
          scale: [1, 8, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_pillar_4',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [25, 0, 25],
          rotation: [0, 0, 0],
          scale: [1, 8, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral torches
        {
          id: 'obj_torch_1',
          name: 'Torche Spectrale',
          type: 'static',
          modelId: 'crystal',
          position: [6, 2, 15],
          rotation: [0, 0, 0],
          scale: [0.3, 1, 0.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_torch_2',
          name: 'Torche Spectrale',
          type: 'static',
          modelId: 'crystal',
          position: [24, 4, 15],
          rotation: [0, 0, 0],
          scale: [0.3, 1, 0.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // === Additional decorations for enlarged tower (30x30) ===
        // Corner pillars around the tower
        {
          id: 'obj_tower_corner_pillar_1',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [4, 0, 4],
          rotation: [0, 0, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_tower_corner_pillar_2',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [26, 0, 4],
          rotation: [0, 0, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_tower_corner_pillar_3',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [4, 0, 26],
          rotation: [0, 0, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_tower_corner_pillar_4',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [26, 0, 26],
          rotation: [0, 0, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        // Torch stands
        {
          id: 'obj_tower_torch_stand_1',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [6, 0, 10],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_torch_stand_2',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [24, 0, 10],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Lanterns
        {
          id: 'obj_tower_lantern_1',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [2, 0, 15],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_lantern_2',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [28, 0, 15],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_lantern_3',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [15, 0, 28],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Banners
        {
          id: 'obj_tower_banner_1',
          name: 'Bannière',
          type: 'static',
          modelId: 'banner',
          position: [0.5, 2, 10],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_banner_2',
          name: 'Bannière',
          type: 'static',
          modelId: 'banner',
          position: [29.5, 2, 20],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Debris
        {
          id: 'obj_tower_debris_1',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [22, 0, 6],
          rotation: [0, 0.8, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_debris_2',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [4, 0, 22],
          rotation: [0, 2.1, 0],
          scale: [0.9, 1, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Rocks
        {
          id: 'obj_tower_rock_1',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [26, 0, 14],
          rotation: [0, 1.5, 0],
          scale: [0.8, 0.6, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tower_rock_2',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [2, 0, 24],
          rotation: [0, 2.8, 0],
          scale: [0.7, 0.5, 0.7],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More spectral torches
        {
          id: 'obj_torch_3',
          name: 'Torche Spectrale',
          type: 'static',
          modelId: 'crystal',
          position: [10, 3, 20],
          rotation: [0, 0, 0],
          scale: [0.3, 1, 0.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_torch_4',
          name: 'Torche Spectrale',
          type: 'static',
          modelId: 'crystal',
          position: [18, 5, 22],
          rotation: [0, 0, 0],
          scale: [0.3, 1, 0.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Spectral orbs
        {
          id: 'obj_tower_orb_1',
          name: 'Orbe Spectral',
          type: 'static',
          modelId: 'orb',
          position: [12, 4, 12],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_tower_orb_2',
          name: 'Orbe Spectral',
          type: 'static',
          modelId: 'orb',
          position: [22, 6, 18],
          rotation: [0, 0, 0],
          scale: [0.35, 0.35, 0.35],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_tower_orb_3',
          name: 'Orbe Spectral',
          type: 'static',
          modelId: 'orb',
          position: [6, 2.5, 22],
          rotation: [0, 0, 0],
          scale: [0.45, 0.45, 0.45],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
      ],
      puzzles: [],
      connections: [],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'night',
      biome: 'celestial',
      weather: 'none',
      weatherIntensity: 0,
      npcs: [
        {
          id: 'npc_owl_celestial',
          type: 'owl',
          name: 'Hibou Céleste',
          position: [15, 5, 15],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'chirp',
          petRadius: 3.5,
          petCooldown: 3500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_butterfly_celestial_1',
          type: 'butterfly',
          name: 'Papillon Étoilé',
          position: [10, 3, 20],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 1500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_butterfly_celestial_2',
          type: 'butterfly',
          name: 'Papillon Lunaire',
          position: [20, 4, 10],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 1500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_bird_celestial',
          type: 'bird',
          name: 'Oiseau du Paradis',
          position: [25, 6, 25],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'chirp',
          petRadius: 3,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'both',
        },
      ],
    };
